import { useContext } from 'react';

import { CookiesContext } from './context';

export { default as UserCookiesContainer } from './UserCookiesContainer';

export const useCookies = () => useContext(CookiesContext);
